<template>
  <div class="m-content" >
		<HeaderBox/>
    <div class="report-content">
      <div class="report-area">
        <p class="report-title">你的兴趣类型为</p>
        <h3 class="type-title" v-html="cosHolland.firstType+cosHolland.secondType+cosHolland.thirdType"></h3>
        <p class="type-name" v-html="cosHolland.typeName"></p>
        <template>
            <img class="report-img holland-img" :src="hollandFirstTypeImgSrc"/>
            <img class="report-img holland-img" :src="hollandSecondTypeImgSrc"/>
            <img class="report-img holland-img" :src="hollandThirdTypeImgSrc"/>
        </template>
      </div>
      <div class="report-area">
        <p class="report-title">各维度得分</p>
        <img class="report-img score-img":src=cosHolland.hollandImage />
      </div>
    </div>
		<FootBox :id="id"/>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import axios from 'axios'
import qs from 'qs'
import HeaderBox from '@/components/mission/headerBox.vue'
import FootBox from '@/components/mission/footBox.vue'
import setWechatTitle from '@/utils/setWechatTitle.js'
export default {
  props: {
    id: Number
  },
  name: 'HollandReport',
  components: {
    HeaderBox,
    FootBox
  },
  data() {
    return {
      cosHolland:''
    };
  },
  computed: {
    ...mapState({
      shengyaUser: state => state.shengyaUser.userInfo,
    }),
		hollandFirstTypeImgSrc() {
		  return 'http://sys.rennengda.com/public/images/holland/' + this.cosHolland.firstType+ '.png'
		},
		hollandSecondTypeImgSrc() {
		  return 'http://sys.rennengda.com/public/images/holland/' + this.cosHolland.secondType+ '.png'
		},
		hollandThirdTypeImgSrc() {
		  return 'http://sys.rennengda.com/public/images/holland/' + this.cosHolland.thirdType+ '.png'
		},
  },
  created: function () {
    setWechatTitle('生涯驿站-职业倾向测评')
    this.getReport()
  },
  methods:{
    getReport(){
        const options = {
          method: 'post',
          headers: {'content-type': 'application/x-www-form-urlencoded'},
          data: qs.stringify({
            openId: this.shengyaUser.openid
          }),
          url:'/cob/cosHollandReport.do'
        };
        axios(options)
        .then((response)=>{
          if(response.data.result.success){
            let Result = response.data.data;
             if(Result){
               this.cosHolland=Result.cosHolland
                let num = Math.round(Math.random()),
                text = '的兴趣类型居然是'+this.cosHolland.firstType+this.cosHolland.secondType+this.cosHolland.thirdType+'，哈哈'
                if(num){
                  text='是'+this.cosHolland.typeName+'，不会吧'
                }
                store.dispatch('finishPlay', {missionId:this.id,cosAnswer:text})
             }
          }
        })
        .catch((error)=>{
          console.log(error);
        })
    }
  }
}
</script>
<style scoped>
</style>
